import { useEffect, useState } from "react";
import { bool, object, string } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { MAX_COLUMN_DISPLAY_NAME } from "@utils";
import { useEstimateStructure } from "@tools";
import { TextClearInput } from "@components";

export const DescriptionTitleEditor = observer(({
  columnSettings,
  className,
  inputClassName,
  preventBlurOnRelatedTarget,
}) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  
  const { id, displayName } = columnSettings;
  
  const [ value, setInputValue ] = useState(displayName);
  const [ focused, setFocus ] = useState(false);
  
  useEffect(() => {
    setInputValue(displayName || t("common.desc"));
  }, [ displayName ]);
  
  const handleNameChange = (v) => {
    setInputValue(v.slice(0, MAX_COLUMN_DISPLAY_NAME));
  }
  
  const handleNameAccept = () => {
    setFocus(false);
    if(!value.length) {
      setInputValue(displayName);
      return;
    }
    
    structure.setBreakdownColumnDisplayName(id, value);
  }
  
  const handleFocus = () => {
    setFocus(true);
  };
  
  return (
    <TextClearInput
      noButtons
      multiline
      onChange={handleNameChange}
      value={value}
      focused={focused}
      onFocus={handleFocus}
      onAccept={handleNameAccept}
      // acceptOnClickAway
      lockSpecialCharacters={false}
      placeholder={t("common.desc")}
      confirmOnEnter
      scaleWidthToContent
      className={className}
      inputClassName={inputClassName}
      preventBlurOnRelatedTarget={preventBlurOnRelatedTarget}
    />
  )
})

DescriptionTitleEditor.propTypes = {
  columnSettings: object.isRequired,
  className: string,
  inputClassName: string,
  preventBlurOnRelatedTarget: bool,
}